import { Quote, Sparkles, Handshake, Heart } from "lucide-react";

export default function Testimonials() {
  return (
    <section className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="max-w-2xl mb-14">
          <div className="overline mb-4">A note from the founder</div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#183D36]">
            No fake testimonials. Just the work.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-3" data-testid="testimonials-founder-note">
            <div className="rounded-3xl bg-[#A8BFA3] text-[#183D36] p-8 sm:p-12">
              <Quote size={28} className="text-[#183D36]/60 mb-4" />
              <blockquote className="font-heading text-xl sm:text-2xl leading-snug text-[#183D36] mb-6">
                &ldquo;NextVisit is what I wish had existed when I was running my own studio.
                I built it because the tools out there were bloated, priced like enterprise software,
                and treated small operators like an afterthought.&rdquo;
              </blockquote>
              <blockquote className="text-base leading-relaxed text-[#183D36]/90 mb-6">
                &ldquo;We&apos;re early. If you sign up now, you get real conversations with me — not a
                ticket queue — and your feedback shapes the product. When we do have customer stories
                worth sharing, they&apos;ll show up here with real names, real photos, and real results.&rdquo;
              </blockquote>
              <figcaption className="flex items-center gap-3 pt-4 border-t border-[#183D36]/15">
                <span className="w-11 h-11 rounded-full bg-[#183D36] text-[#F4B183] flex items-center justify-center">
                  <Heart size={16} />
                </span>
                <div>
                  <div className="font-medium text-[#183D36]">Brooke Tomlin</div>
                  <div className="text-sm text-[#183D36]/70">Founder, NextVisit</div>
                </div>
              </figcaption>
            </div>
          </div>

          <div className="lg:col-span-2 space-y-4" data-testid="testimonials-promises">
            <PromiseCard
              icon={Handshake}
              title="Founding-customer support"
              body="Direct line to Brooke while we&apos;re early. She personally onboards every new workspace."
            />
            <PromiseCard
              icon={Sparkles}
              title="Product shaped by you"
              body="Something missing? Say the word and it gets built. That&apos;s the tradeoff for joining early."
            />
            <PromiseCard
              icon={Heart}
              title="Real results, on your terms"
              body="Cancel any time. If NextVisit doesn&apos;t earn its keep in the first month, we&apos;ll refund you."
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function PromiseCard({ icon: Icon, title, body }) {
  return (
    <div className="rounded-2xl bg-white border border-[#E5E0D8] p-5">
      <span className="w-10 h-10 rounded-2xl bg-[#183D36] text-[#F4B183] flex items-center justify-center mb-3">
        <Icon size={16} />
      </span>
      <h3 className="font-heading text-lg text-[#183D36] mb-1">{title}</h3>
      <p className="text-sm text-[#4A4A4A] leading-relaxed">{body}</p>
    </div>
  );
}
